import { EventService } from './eventService';
import ModelFunctionDocJson from '../generated/modelFunctionDocs.json';
import { AuthService } from './authService';
import { CalculationService } from './calculationService';
import { DataLoadService } from './dataLoadService';
import { DocumentService } from './documentService';
import { LookupService } from './lookupService';
import { ModelService } from './modelService';
import { StatusService } from './statusService';
import { TestCaseService } from './testCaseService';

export * from './authService';
export * from './calculationLogService';
export * from './calculationService';
export * from './dataLoadService';
export * from './documentService';
export * from './helpers';
export * from './lookupService';
export * from './modelService';
export * from './statusService';
export * from './testCaseService';
export * from './types';
export * from './eventService';

export const ModelFunctionDocs = ModelFunctionDocJson;

export class InsightServicesLibrary {
  private readonly lookupService: LookupService;
  private readonly calculationService: CalculationService;
  private readonly modelService: ModelService;
  private readonly authService: AuthService;
  private readonly dataLoadService: DataLoadService;
  private readonly statusService: StatusService;
  private readonly documentService: DocumentService;
  private readonly testCaseService: TestCaseService;
  private readonly eventService: EventService;

  constructor(domain: string = '') {
    this.lookupService = new LookupService(domain);
    this.calculationService = new CalculationService(domain);
    this.modelService = new ModelService(domain);
    this.dataLoadService = new DataLoadService(domain);
    this.statusService = new StatusService(domain);
    this.documentService = new DocumentService(domain);
    this.testCaseService = new TestCaseService(domain);
    this.authService = new AuthService(domain);
    this.eventService = new EventService(domain);

    this.createLookupTable = this.lookupService.createTable;
    this.updateActiveTableVersion = this.lookupService.updateActiveTableVersion;
    this.getLookupTableMembers = this.lookupService.getTableMembers;
    this.getLookupTableList = this.lookupService.getAllTables;
    this.patchMembersOnTableVersion = this.lookupService.patchMembersOnTableVersion;
    this.deleteMembersOnTableVersion = this.lookupService.deleteMembersOnTableVersion;
    this.deleteTableVersion = this.lookupService.deleteTableVersion;

    this.getCalculationDetails = this.calculationService.getCalculationDetails;
    this.performModelCalculation = this.calculationService.performModelCalculation;

    this.createModel = this.modelService.createModel;
    this.deleteModel = this.modelService.deleteModel;
    this.getModel = this.modelService.getModel;
    this.getModelList = this.modelService.getModelList;
    this.updateModel = this.modelService.updateModel;
    this.updateModelInputs = this.modelService.updateModelInputs;

    this.getAllDataLoads = this.dataLoadService.getAllDataLoads;

    this.createStatusEntry = this.statusService.createStatusEntry;
    this.getStatusEntriesByFilter = this.statusService.getStatusEntriesByFilter;

    this.getDocumentsByType = this.documentService.getDocumentsByType;
    this.saveDocument = this.documentService.saveDocument;
    this.getDocument = this.documentService.getDocument;
  }

  createLookupTable: LookupService['createTable'];
  updateActiveTableVersion: LookupService['updateActiveTableVersion'];
  getLookupTableMembers: LookupService['getTableMembers'];
  getLookupTableList: LookupService['getAllTables'];
  patchMembersOnTableVersion: LookupService['patchMembersOnTableVersion'];
  deleteMembersOnTableVersion: LookupService['deleteMembersOnTableVersion'];
  deleteTableVersion: LookupService['deleteTableVersion'];

  getCalculationDetails: CalculationService['getCalculationDetails'];
  performModelCalculation: CalculationService['performModelCalculation'];

  createModel: ModelService['createModel'];
  deleteModel: ModelService['deleteModel'];
  getModel: ModelService['getModel'];
  getModelList: ModelService['getModelList'];
  updateModel: ModelService['updateModel'];
  updateModelInputs: ModelService['updateModelInputs'];

  getAllDataLoads: DataLoadService['getAllDataLoads'];

  createStatusEntry: StatusService['createStatusEntry'];
  getStatusEntriesByFilter: StatusService['getStatusEntriesByFilter'];

  getDocumentsByType: DocumentService['getDocumentsByType'];
  saveDocument: DocumentService['saveDocument'];
  getDocument: DocumentService['getDocument'];
}
